import { plainToInstance, Type } from 'class-transformer';
import { ArrayMinSize, IsArray, IsInt, IsPositive } from 'class-validator';
import { BankAccountDto } from './bank-account.dto';
import { CashflowDto } from './cashflow.dto';
import { PayOrderGroup, PayOrderStatus } from './enums/payorder';
import { Identifiable } from './identifiable';
import { InvoiceDto, InvoiceForCashFlowReportDto } from './invoice.dto';


export class PayOrderDto extends Identifiable {
  description: string;
  group: PayOrderGroup;

  bankAccount: BankAccountDto;
  @Type()
    counterpartyAccount?: BankAccountDto;
  cashflow: CashflowDto;

  status: PayOrderStatus;
  documentNumber: string;

  @Type()
    paymentDate: Date;

  @Type(() => PayOrderRowDto)
    rows: PayOrderRowDto[];

  static fromPlain(plain: any) { return plainToInstance(PayOrderDto, plain) }
}

export class CreatePayOrderDto {
  status: PayOrderStatus;
  description: string;
  documentNumber: string;

  @Type()
    paymentDate: Date;

  group: PayOrderGroup;
  accountId: number;

  @IsInt()
  @IsPositive()
    cashflowId: number;

  @Type()
  @IsArray()
  @ArrayMinSize(1)
    rows: CreateUpdatePayOrderRowDto[];
}

export class UpdatePayOrderDto extends CreatePayOrderDto implements Identifiable {
  id: number;
}

export class CreateTransferPayOrderDto {
  @Type()
  paymentDate: Date;

  description: string;
  outgoingDocumentNumber?: string;
  incomingDocumentNumber?: string;
  fromAccountId: number;
  toAccountId: number;
  amount: number;
  status?: PayOrderStatus;
}

export class TransferPayOrderDto {
  @Type(() => PayOrderDto)
  outgoingPayOrder: PayOrderDto;

  @Type(() => PayOrderDto)
  incomingPayOrder: PayOrderDto;
}

export declare class UpdatePayOrderStatusDto {
  status: PayOrderStatus;
  id: number;
  paymentDate: Date | null;
}

export declare class UpdatePayOrderDateDto {
  id: number;
  paymentDate: Date | null;
}

export class CreateUpdatePayOrderRowDto {
  id: number;
  invoiceId?: number;
  salaryEntryId?: number;
  amount: number;
}

export class PayOrderRowDto extends CreateUpdatePayOrderRowDto {
  @Type(() => InvoiceDto)
    invoice: InvoiceDto;
}

export class PayOrderRowForCashflowReportDto {
  amount: number;
  @Type(() => InvoiceForCashFlowReportDto)
    invoice: InvoiceForCashFlowReportDto;
}
